import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceDescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const BadgeWrapper = styled.div`
  margin-right: ${Spacing.S8};
`
